import FormLabel from '@mui/material/FormLabel'
import { InputLabelProps } from '@mui/material/InputLabel'
import MuiTextField, { TextFieldProps } from '@mui/material/TextField'

const TextField: React.FC<TextFieldProps> = (props) => {
  return (
    <MuiTextField
      {...props}
      variant="outlined"
      fullWidth
      margin="normal"
      slotProps={{
        inputLabel: {
          for: props.id,
          hidden: false,
          shrink: false
        } as InputLabelProps,
        ...props.slotProps
      }}
      slots={{
        inputLabel: FormLabel
      }}
    />
  )
}

export default TextField
